import React from "react";
import { TrackingCaseDocumentFieldValueListTemplate } from "themes/application/tracking-case/pages";
import { observer } from "mobx-react";
import { TrackingCaseDocumentFieldValueListViewStore } from "application/tracking-case/stores";
import { setCurrentView } from "core/utils";

@setCurrentView(rootStore => new TrackingCaseDocumentFieldValueListViewStore(rootStore), "trackingCaseDocumentFieldValueListViewStore")
@observer
class TrackingCaseDocumentFieldValueListView extends React.Component {
    render() {
        return <TrackingCaseDocumentFieldValueListTemplate {...this.props} />;
    }
}

export default TrackingCaseDocumentFieldValueListView;